<div fxLayout="row" fxLayoutGap="2em" fxLayoutAlign="space-between center">
  <div class="small" fxFlex="100">
    <mat-form-field appearance="outline" floatLabel="never" style="width: 100%">
      <input
        type="text"
        matInput
        #input
        placeholder="Search by company..."
        (keyup.enter)="searchOrder(input.value)"
        autocomplete="off"
        (focusout)="focusOut(input.value)"
      />
      <div class="button-search" (click)="searchOrder(input.value)">
        <span class="material-icons search"> search </span>
      </div>
    </mat-form-field>
  </div>
</div>
